import {MinerInventoryInterface} from '@/types/types'

export const extractMiners = (data: unknown): MinerInventoryInterface[] => {
  if (!data || typeof data !== 'object') return []

  const result: MinerInventoryInterface[] = []

  Object.values(data as Record<string, unknown>).forEach((value) => {
    if (!Array.isArray(value)) return
    value.forEach((item) => {
      if (item && typeof item === 'object' && 'miner_id' in item) {
        result.push(item as MinerInventoryInterface)
      }
    })
  })

  return result
}
